module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img31.d06ea8d5.jpg";